import { Injectable } from '@angular/core';
import { isCapacitorNative } from '../platform/capacitor-platform';
import { LoggerService } from '../utils/logger.service';
import { BRAND } from '../brand/brand';

export interface StoredPolicyAcceptance {
  userId: number;
  termsVersion: string;
  privacyVersion: string;
  acceptedAt: string;
}

const KEY_PREFIX = `${BRAND.storagePrefix}.policy-acceptance.`;

@Injectable({ providedIn: 'root' })
export class PolicyAcceptanceStorageService {
  async save(acceptance: StoredPolicyAcceptance): Promise<void> {
    const key = this.key(acceptance.userId);
    const value = JSON.stringify(acceptance);
    try {
      if (isCapacitorNative()) {
        const { Preferences } = await import('@capacitor/preferences');
        await Preferences.set({ key, value });
      } else {
        localStorage.setItem(key, value);
      }
    } catch (error) {
      LoggerService.error('[policy] Could not persist acceptance', error);
    }
  }

  async isCurrent(userId: number, termsVersion: string, privacyVersion: string): Promise<boolean> {
    try {
      const key = this.key(userId);
      const raw = isCapacitorNative()
        ? (await import('@capacitor/preferences').then(({ Preferences }) => Preferences.get({ key }))).value
        : localStorage.getItem(key);
      if (!raw) return false;
      const acceptance = JSON.parse(raw) as StoredPolicyAcceptance;
      return acceptance.userId === userId
        && acceptance.termsVersion === termsVersion
        && acceptance.privacyVersion === privacyVersion
        && !!acceptance.acceptedAt;
    } catch (error) {
      LoggerService.error('[policy] Could not read persisted acceptance', error);
      return false;
    }
  }

  private key(userId: number): string {
    return `${KEY_PREFIX}${userId}`;
  }
}
